import { Injectable } from '@angular/core';
import {
  LxpAdminGuards,
  LxpLearnerGuards,
  PermissionFactory,
} from '@app/layout/v3/permission.factory';
import {
  AuthService,
  LDFlagsService,
  ContextService,
  WebEnvironmentService,
} from '@dg/shared-services';

/**
 * @deprecated This is a temporary measure to allow a way to keep guards in sync until we have a better
 * source of truth implemented by re-mapping our permissions.
 */
@Injectable({ providedIn: 'root' })
export class PermissionsFactoryProxyService {
  public admin: LxpAdminGuards;
  public lxp: LxpLearnerGuards;

  constructor(
    private authService: AuthService,
    private featureFlags: LDFlagsService,
    private contextService: ContextService,
    private environment: WebEnvironmentService
  ) {
    const permissionFactory = new PermissionFactory(
      this.authService.authUser,
      this.featureFlags,
      this.contextService,
      this.environment
    );

    this.admin = permissionFactory.forLxpAdmin();
    this.lxp = permissionFactory.forLxpLearner();
  }
}
